import { render, staticRenderFns } from "./userinfoadd.vue?vue&type=template&id=9c8b550c&scoped=true"
import script from "./userinfoadd.vue?vue&type=script&lang=js"
export * from "./userinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8b550c",
  null
  
)

export default component.exports